import { render } from "./IconReturn.vue?vue&type=template&id=077595f0"
const script = {}
script.render = render

export default script